import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Button, Paper } from '@mui/material';
import {
  listUserPreference,
  getFinancialYear,
} from '../../../../graphql';
import { useDispatch, useSelector } from 'react-redux';
import { fySettingsfalse } from '../../../../redux/reducers/fySettings';
import YearEndClosingandFreezing from '../../../../components/modals/YearEndClosingandFreezing';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { API, graphqlOperation } from 'aws-amplify';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import FYClosingBalancelist from '../../../../components/Drawers/FYClosingBalancelist';
import { showErrorSnackbar, showWarningSnackbar } from '../../../../components/snackBar/snakbar';
import { formatUnixTimestamp } from '../../../../library';


function FinancialYearSettings({ expanded }) {

  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const [openTransferCloseModal, setOpenTransferCloseModal] = useState(false);
  const [selectButton, setSelectButton] = useState('');
  const [nextFYPreview, setNextFYPreview] = useState('');
  const [confirmTransfer, setConfirmTransfer] = useState(false);
  const [fyid, setfyid] = useState(null);
  const [freeze, setFreeze] = useState(false);
  const [fromFYObj, setFromFYObj] = useState(null);
  const [toFYObj, setToFYObj] = useState(null);

  const { listFYData: listFyear } = useSelector((state) => state.userPrefrenceandReducer);

  const handleClosingBalance = (year, FYID) => {
    const [FromFYObj, ToFYObj] = [listFyear.find((obj) => obj?.financialyearid === FYID), listFyear.find((obj) => obj.startyear === year)];

    if (ToFYObj?.freezestatus === 1) {
      showWarningSnackbar(`Balance transfer not allowed to a frozen financial year (${ToFYObj?.startyear}-${ToFYObj?.endyear})`);
      return;
    }

    setFromFYObj(FromFYObj);
    setToFYObj(ToFYObj);
    setNextFYPreview(listFyear.filter((yearr) => yearr.startyear === year));
    setOpenTransferCloseModal(true);
    setSelectButton('transfer');
  };

  const handleFreeze = async (fyID, status) => {
    const checkNextFy = listFyear.find((year) => year.financialyearid === fyID);
    setFromFYObj(checkNextFy);
    setToFYObj(checkNextFy);
    setNextFYPreview([checkNextFy]);
    setOpenTransferCloseModal(true);
    setSelectButton('lock&freeze');
    setfyid(fyID);
    setFreeze(status);
  };

  async function fetchData() {
    try {
      const res = await API.graphql(graphqlOperation(listUserPreference));
      const selectedFinYear = res?.data?.listUserPreference.find((ele) => ele.attributetypecd === 'SelectedFinYear');

      if (selectedFinYear) {
        await API.graphql(
          graphqlOperation(getFinancialYear, {
            financialyearid: selectedFinYear.attributevalue,
          })
        );
      }

      dispatch(fySettingsfalse());
    } catch (error) {
      showErrorSnackbar('Error fetching financial year data');
    }
  }
  const location = useLocation();
  useEffect(() => {
    if (expanded || location.pathname === '/financialyearsettings') {
      fetchData();
    }
  }, []);

  return (
    <>
      <Paper
        sx={{
          p: 2,
          mb: 2,
          borderRadius: '12px',
          border: '2px solid #e0e9ff',
          boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
          background: 'linear-gradient(to right, #f8faff, #ffffff)',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: '4px',
            backgroundColor: 'primary.main',
            borderRadius: '4px 0 0 4px',
          },
        }}
      >
        <Typography
          sx={{
            color: 'text.primary',
            fontSize: '15px',
            lineHeight: '1.6',
            fontWeight: 400,
            letterSpacing: '0.2px',
            fontFamily: 'inherit',
            '& strong': {
              color: 'primary.main',
              fontWeight: 600,
            },
          }}
        >
          When you create a <strong>new financial year</strong>, we'll automatically transfer all your active and inactive groups, ledgers,
          and items forward. This means you won't need to recreate any ledger accounts, making it super easy to jump right into your new
          year's transactions! Your closing balances will also carry over, and if you need to update them later due to any changes this
          year, you can re-transfer them anytime.
        </Typography>
        <Box mt={2}>
          <Typography
            component="span"
            variant="body2"
            sx={{ 
              fontWeight: 600, 
              color: 'warning.main', 
              fontSize: '14px', 
              lineHeight: '1.6', 
              letterSpacing: '0.2px',
              fontFamily: 'inherit'
            }}
          >
            ⚠️Caution:&nbsp;
          </Typography>
          Next year means immediate year , otherwise the balances can not be transfered but all ledgers and groups and stocks id and name
          can be transfered.
        </Box>
        
      </Paper>{' '}
      <Paper
        sx={{
          padding: { xs: '8px', sm: '12px', md: '16px', lg: '20px' },
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          borderRadius: '12px',
          border: '2px solid',
          borderColor: 'bodyGray.main',
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: { xs: '8px', sm: '10px', md: '12px' },
          width: '100%'
        }}>
          <Button
            variant="contained"
            sx={{
              fontSize: { xs: '13px', sm: '14px', md: '15px' },
              fontWeight: '600',
              fontFamily: 'inherit',
              minHeight: { xs: '40px', sm: '44px', md: '48px' },
              backgroundColor: 'linear-gradient(135deg, #0e9aeb 0%, #0d7bc7 50%, #0b6bb3 100%)',
              background: 'linear-gradient(135deg, #0e9aeb 0%, #0d7bc7 50%, #0b6bb3 100%)',
              width: { xs: '100%', sm: 'auto' },
              maxWidth: { xs: 'none', sm: '220px' },
              alignSelf: { xs: 'stretch', sm: 'flex-start' },
              borderRadius: '12px',
              textTransform: 'none',
              letterSpacing: '0.5px',
              boxShadow: '0 4px 15px rgba(14, 154, 235, 0.3), 0 2px 8px rgba(14, 154, 235, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                backgroundColor: 'linear-gradient(135deg, #0d7bc7 0%, #0b6bb3 50%, #0a5ca0 100%)',
                background: 'linear-gradient(135deg, #0d7bc7 0%, #0b6bb3 50%, #0a5ca0 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(14, 154, 235, 0.4), 0 4px 12px rgba(14, 154, 235, 0.3)',
                '&::before': {
                  opacity: 1,
                  transform: 'scale(1)',
                }
              },
              '&:active': {
                transform: 'translateY(0px)',
                boxShadow: '0 2px 8px rgba(14, 154, 235, 0.3)',
              },
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
                opacity: 0,
                transform: 'scale(0.8)',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '0',
                height: '0',
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
                transition: 'all 0.6s ease',
              },
              '&:hover::after': {
                width: '300px',
                height: '300px',
              }
            }}
            onClick={() => navigate('/create-new-financial-year')}
          >
            Create FY
          </Button>
          
          <Typography
            variant="h6"
            sx={{
              fontWeight: '700',
              fontSize: { xs: '14px', sm: '15px', md: '16px' },
              fontFamily: 'inherit',
              color: 'text.primary',
              marginBottom: { xs: '4px', sm: '6px', md: '8px' }
            }}
          >
            Created Financial Years
          </Typography>
          
          <Box sx={{ width: '100%' }}>
            {[...(listFyear || [])]
              ?.sort((a, b) => {
                const yearA = parseInt(a?.startyear);
                const yearB = parseInt(b?.startyear);
                return yearA - yearB;
              })
              ?.map((item, index) => {
                const freezeDate = formatUnixTimestamp(item?.freezedate)
                const previrewDate =  `${formatUnixTimestamp(item?.startdate)} to ${formatUnixTimestamp(item?.enddate)}`;

                return (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: 'row' },
                      alignItems: { xs: 'stretch', sm: 'stretch', md: 'stretch', lg: 'center' },
                      gap: { xs: '8px', sm: '10px', md: '10px', lg: '16px' },
                      padding: { xs: '8px', sm: '10px', md: '10px', lg: '12px' },
                      marginBottom: { xs: '6px', sm: '8px' },
                      borderRadius: '8px',
                      border: '1px solid',
                      borderColor: 'divider',
                      backgroundColor: 'background.paper',
                      transition: 'all 0.2s ease-in-out',
                      width: '100%',
                      boxSizing: 'border-box',
                      '&:hover': {
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        borderColor: 'primary.light',
                      },
                    }}
                  >
                    {/* FY Preview */}
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      flexShrink: 0,
                      minWidth: { xs: 'auto', sm: 'auto', md: 'auto', lg: '300px' },
                      maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: '350px' }
                    }}>
                      <KeyboardArrowRightIcon sx={{ 
                        marginRight: { xs: '6px', sm: '8px', md: '8px', lg: '8px' }, 
                        flexShrink: 0,
                        fontSize: { xs: '20px', sm: '22px', md: '22px', lg: '24px' },
                        color: 'primary.main'
                      }} />
                      <Typography sx={{ 
                        color: 'text.primary',
                        fontSize: { xs: '12px', sm: '13px', md: '13px', lg: '14px' },
                        fontWeight: '600',
                        fontFamily: 'inherit',
                        lineHeight: '1.4',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        backgroundColor: 'rgba(240, 248, 255, 0.8)',
                        padding: { xs: '4px 8px', sm: '6px 10px', md: '6px 10px', lg: '6px 12px' },
                        borderRadius: '6px',
                        border: '1px solid rgba(200, 220, 240, 0.6)',
                        cursor: 'default',
                        userSelect: 'none',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                          backgroundColor: 'rgba(240, 248, 255, 0.9)',
                          borderColor: 'rgba(200, 220, 240, 0.8)'
                        }
                      }}>
                        {previrewDate}
                      </Typography>
                    </Box>

                    {/* Buttons and Dates Container - All in one row for medium+ devices */}
                    <Box sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
                      gap: { xs: '8px', sm: '10px', md: '8px', lg: '8px' },
                      flex: { xs: '1', sm: '1', md: '1', lg: '1' },
                      alignItems: { xs: 'stretch', sm: 'stretch', md: 'center', lg: 'center' },
                      minWidth: 0,
                      flexWrap: { xs: 'nowrap', sm: 'nowrap', md: 'nowrap', lg: 'nowrap' }
                    }}>
                      {/* Transfer Button */}
                      <Button
                        sx={{
                          fontSize: { xs: '10px', sm: '11px', md: '11px', lg: '12px' },
                          fontWeight: '500',
                          fontFamily: 'inherit',
                          minHeight: { xs: '32px', sm: '36px', md: '36px', lg: '40px' },
                          textTransform: 'none',
                          borderColor: 'primary.main', 
                          color: 'primary.main',
                          padding: { xs: '6px 8px', sm: '8px 12px', md: '8px 12px', lg: '10px 16px' },
                          borderRadius: '4px',
                          flex: { xs: '1', sm: '1', md: '0 1 auto', lg: '0 1 auto' },
                          minWidth: { xs: 'auto', sm: 'auto', md: '200px', lg: '320px' },
                          maxWidth: { xs: 'none', sm: 'none', md: 'none', lg: '320px' },
                          whiteSpace: { xs: 'normal', sm: 'normal', md: 'nowrap', lg: 'nowrap' },
                          textAlign: 'center',
                          '&:hover': {
                            borderColor: 'primary.dark',
                            backgroundColor: 'primary.dark',
                            color: 'white'
                          },
                          '&:disabled': {
                            borderColor: 'rgba(0, 0, 0, 0.26)',
                            color: 'rgba(0, 0, 0, 0.6)',
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            opacity: 1
                          },
                        }}
                        disabled={item?.freezestatus === 1}
                        variant="outlined"
                        onClick={() =>
                          handleClosingBalance(
                            item.startyear === item.endyear ? (parseInt(item.endyear) + 1).toString() : item.endyear,
                            item?.financialyearid
                          )
                        }
                      >
                        Transfer Closing Balance to Next FY
                      </Button>

                      {/* Freeze Button */}
                      <Button
                        sx={{
                          fontSize: { xs: '10px', sm: '11px', md: '11px', lg: '12px' },
                          fontWeight: '500',
                          fontFamily: 'inherit',
                          minHeight: { xs: '32px', sm: '36px', md: '36px', lg: '40px' },
                          textTransform: 'none',
                          borderColor: 'primary.main',
                          color: 'primary.main',
                          padding: { xs: '6px 8px', sm: '8px 12px', md: '8px 12px', lg: '10px 16px' },
                          borderRadius: '4px',
                          flex: { xs: '1', sm: '1', md: '0 1 auto', lg: '0 1 auto' },
                          minWidth: { xs: 'auto', sm: 'auto', md: '100px', lg: '180px' },
                          maxWidth: { xs: 'none', sm: 'none', md: 'none', lg: '180px' },
                          whiteSpace: { xs: 'normal', sm: 'normal', md: 'nowrap', lg: 'nowrap' },
                          textAlign: 'center',
                          '&:hover': {
                            borderColor: 'primary.dark',
                            backgroundColor: 'primary.dark',
                            color: 'white'
                          },
                        }}
                        variant="outlined"
                        onClick={() => handleFreeze(item?.financialyearid, item?.freezestatus)}
                      >
                        {item?.freezestatus == 0 ? 'Freeze FY' : 'UnFreeze FY'}
                      </Button>

                      {/* Dates - Column-wise for large devices, inline for medium */}
                      {(item?.transferdate || item?.freezedate) && (
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'column' },
                          alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center', lg: 'flex-start' },
                          gap: { xs: '4px', sm: '4px', md: '8px', lg: '1px' },
                          flex: { xs: '0 0 auto', sm: '0 0 auto', md: '0 0 auto', lg: '0 0 auto' },
                          minWidth: { xs: '150px', sm: '180px', md: 'auto', lg: '200px' },
                          maxWidth: { xs: '100%', sm: '100%', md: 'none', lg: '250px' },
                          marginLeft: { xs: '0px', sm: '0px', md: '0px', lg: '0px' }
                        }}>
                          {item?.transferdate && (
                            <Typography
                              sx={{
                                color: 'text.secondary',
                                fontSize: { xs: '10px', sm: '11px', md: '11px', lg: '11px' },
                                fontWeight: '500',
                                fontFamily: 'inherit',
                                whiteSpace: 'nowrap',
                                lineHeight: '1.2',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              Last Transferred: {formatUnixTimestamp(item?.transferdate)}
                              {/* Last Transferred: {formatUnixTimestamp(item?.transferdate)} {item?.transferdate} */}
                            </Typography>
                          )}
                          {item?.freezedate && (
                            <Typography
                              sx={{
                                color: 'text.secondary',
                                fontSize: { xs: '10px', sm: '11px', md: '11px', lg: '11px' },
                                fontWeight: '400',
                                fontFamily: 'inherit',
                                whiteSpace: 'nowrap',
                                lineHeight: '1.2',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              {item?.freezestatus === 1
                                ? `Freezed: ${freezeDate}`
                                : `Unfreezed: ${freezeDate}`}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Box>
                );
              })}
          </Box>
        </Box>

        {openTransferCloseModal && (
          <YearEndClosingandFreezing
            open={openTransferCloseModal}
            item={selectButton}
            fyid={fyid}
            status={freeze}
            listFyear={listFyear}
            nextFYPreview={nextFYPreview}
            handleTransfer={setConfirmTransfer}
            setOpenModal={setOpenTransferCloseModal}
            FromFYObj={fromFYObj}
            ToFYObj={toFYObj}
          />
        )}
        {confirmTransfer && <FYClosingBalancelist open={confirmTransfer} setConfirmTransfer={setConfirmTransfer} />}
      </Paper>
    </>
  );
}

export default FinancialYearSettings;
